const FILTER_TEMPLATE = `
  <label style="padding-left: 4px;">
  <input type="radio" name="RANDOM"/>
  FILTER_NAME
  </label>`;

export const FILTER_NONE = 'none';
export const FILTER_NO = '0';
export const FILTER_YES = '1';

const FILTER_NAMES = ['No Filter', 'No', 'Yes'];
const FILTER_VALUES = [FILTER_NONE, FILTER_NO, FILTER_YES];

export class BoolFilter {
  init(params) {
    this.filterChangedCallback = params.filterChangedCallback;
    this.selected = FILTER_NONE;
    this.valueGetter = params.valueGetter;
  }

  getGui() {
    const eGui = document.createElement('div');
    const eInstructions = document.createElement('div');
    eGui.appendChild(eInstructions);

    const random = Math.random().toString();

    const that = this;
    FILTER_NAMES.forEach((name, index) => {
      const eFilter = document.createElement('div');
      eFilter.style.marginTop = '3px';
      eFilter.innerHTML = FILTER_TEMPLATE.replace('FILTER_NAME', name).replace('RANDOM', random);
      const eRadio = eFilter.querySelector('input');
      if ((this.selected == null
          && index === 0)
          || this.selected === FILTER_VALUES[index]) {
        eRadio.checked = true;
      }
      eGui.appendChild(eFilter);

      eRadio.addEventListener('click', () => {
        that.selected = FILTER_VALUES[index];
        that.filterChangedCallback();
      });
    });

    return eGui;
  }

  doesFilterPass(params) {
    const value = this.valueGetter(params);

    if (value) {
      return value.toString() === this.selected;
    }

    return false;
  }

  isFilterActive() {
    return this.selected !== FILTER_NONE;
  }

  getModel() {
    if (this.selected === FILTER_NONE) {
      return null;
    }

    return {
      filterType: 'text',
      type: 'equals',
      filter: this.selected === FILTER_YES ? FILTER_YES : FILTER_NO,
    };
  }

  setModel(model) {
    if (model == null) {
      this.selected = FILTER_NO;
      this.filterChangedCallback();
      return;
    }

    this.selected = model.filter === FILTER_YES ? FILTER_YES : FILTER_NO;
    this.filterChangedCallback();
  }
}

export default BoolFilter;
